import { useMemo } from 'react';
import webCore from '@happylife-a/web-core';

export default function useLocaleFromUrlWithLocales(
  pathname,
  availableLocales,
  initialPrefix = ''
) {
  const { defaultLocale } = webCore.contexts.useTranslation();

  const locale = useMemo(() => {
    let url = pathname;
    url = url.startsWith('/') ? url.substring(1) : url;
    const segments = url.split('/');

    const normalizedPrefix = (initialPrefix || '').replace(/^\/+|\/+$/g, '');
    let cursor = 0;
    if (normalizedPrefix && segments[0] === normalizedPrefix) {
      cursor = 1;
    }

    if (segments.length > cursor && availableLocales.includes(segments[cursor])) {
      return segments[cursor];
    }

    return defaultLocale;
  }, [pathname, initialPrefix]);

  return locale;
}
